import { RoomApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const roomMemberApi = {
  index: wrap(RoomApi, RoomApi.prototype.indexAdminRoomMember),
  invite: wrap(RoomApi, RoomApi.prototype.inviteRoomMember),
  chngeStatus: wrap(RoomApi, RoomApi.prototype.chngeStatusRoomMember),
  changeOwner: wrap(RoomApi, RoomApi.prototype.changeOwner),
  changePrimarySalesman: wrap(RoomApi, RoomApi.prototype.changePrimarySalesman),
  addRoomMember: wrap(RoomApi, RoomApi.prototype.addRoomMember),
};
